/* eslint-disable no-else-return */
import { Connection, ConnectionType } from '../redux/slices/connectionsSlice';
import connectionService from '../services/community/connectionService';
import localContactService from '../services/community/localContactService';
import tagService from '../services/community/tagService';
import { ConnectionIdentifier } from '../types/misc';
import { CustomField, CustomFieldType } from '../models/inviteService.model';

const filterOnType = (type: ConnectionType) => (cs: ConnectionIdentifier[]) =>
  cs.filter((c) => c.type === type).map((c) => c.dashboardMemberId);
const b2c = filterOnType(ConnectionType.MEMBER);
const loc = filterOnType(ConnectionType.EXTERNAL_MEMBER);

export async function addTag(tagId: string, connections: ConnectionIdentifier[]) {
  // Validate connections before processing
  const invalidConnections = connections.filter(c => !c.dashboardMemberId || !c.type);
  if (invalidConnections.length > 0) {
    console.error('Invalid connections found:', invalidConnections);
    throw new Error(`Invalid connections: ${invalidConnections.length} connection(s) missing id or type`);
  }

  const allDashboardMemberIds = connections.map(c => c.dashboardMemberId);

  await tagService.assignTagToConnections(allDashboardMemberIds, tagId, connections);
}

export async function removeTag(tagId: string, connection: ConnectionIdentifier) {
  await tagService.removeTagFromConnection(connection.dashboardMemberId, tagId, connection.type);
}

export async function getProfilePictureUrl(connection: ConnectionIdentifier): Promise<string> {
  try {
    return await connectionService.getProfilePictureUrl(connection.dashboardMemberId);
  } catch (error) {
    return '';
  }
}

export function mapIdentifiersToConnections(
  allConnections: Connection[],
  identifiers: ConnectionIdentifier[],
): Connection[] {
  return identifiers
    .map((cid) => allConnections.find((c) => c.dashboardMemberId === cid.dashboardMemberId && c.type === cid.type))
    .filter((c) => c !== undefined) as Connection[];
}

export function mapFieldIdentifiersToString(
  customFields: CustomField[],
  selectedFields: (number | string)[],
): string[] {
  return selectedFields.map((fieldId) => {
    if (typeof fieldId === 'string') {
      return fieldId; // field is pre-defined
    }

    const cf = customFields.find((f) => f.customFieldId === fieldId);
    if (cf?.type === CustomFieldType.COMMUNICATION_NAME) {
      return CustomFieldType.COMMUNICATION_NAME;
    }

    if (cf?.type === CustomFieldType.MULTIPLE_CHOICE || cf?.type === CustomFieldType.TEXT) {
      return cf.label;
    }

    return '';
  });
}

export function isConnectionVerafied(c: Connection): boolean {
  return (c.type === ConnectionType.MEMBER);
}

export const filterB2CIds = b2c;
export const filterLocalContactIds = loc;
